import { uploadImageFileReducer } from "./reducers/uploadFileReducer";
import { uploadImageFile, resetImageStore } from "./actions/uploadFile";

const uploadReducers = {
  uploadedImageFile: uploadImageFileReducer,
};

export { uploadImageFile, resetImageStore, uploadReducers };
